export default __webpack_public_path__ + "static/media/distortBottom.75ed825a.svg";